import client, { ApiResponse } from './client';
import i18n from 'i18next';

export interface Agreement {
  id: string;
  title: string;
  content: string;
  isRequired: boolean;
}

const agreementsCache: { [lang: string]: Agreement[] } = {};

export const getAgreements = async (forceRefresh = false): Promise<Agreement[]> => {
  const lang = i18n.language || 'zh-TW';
  
  if (!forceRefresh && agreementsCache[lang]) {
    return agreementsCache[lang];
  }

  const response = await client.get<ApiResponse<Agreement[]>>('/agreements');
  const data = response.data.data;
  agreementsCache[lang] = data;
  return data;
};

export const agreeToAgreement = async (agreementId: string): Promise<boolean> => {
  const response = await client.post<ApiResponse<{ success: boolean; timestamp: number }>>('/agreements/agree', {
    "contentId": agreementId,
  });
  return response.data.data.success;
};
